var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Sect',{staticClass:"SectionWhyWorth"},[_c('Wrap',{staticClass:"lg"},[_c('h2',[_vm._v("Saulės bendruomenės elektrinės savininku tapti verta")]),_c('Row',_vm._l((_vm.whyWorth),function(ref,index){
var icon = ref.icon;
var title = ref.title;
var text = ref.text;
return _c('Column',{key:index,attrs:{"md":4}},[_c('IconColumn',{attrs:{"icon":icon,"text":text,"title":title}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }